export default __webpack_public_path__ + "static/media/analytics.a6e79857.png";